/**
 * login
 */
const TYPE_IS_LOGIN = "typeIsLogin"
const TYPE_LOGIN_INFO = "typeUserLoginInfo"
const TYPE_LOGOUT = "typeLogout"

export {
    TYPE_IS_LOGIN,
    TYPE_LOGIN_INFO,
    TYPE_LOGOUT
}